import { Box, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      data-testid="not-found-page"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
      textAlign="center"
      gap={2}
    >
      <Typography variant="h2" color="primary" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" gutterBottom>
        {t("notFoundTitle", "Page not found")}
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        {t(
          "notFoundMessage",
          "Sorry, the page you are looking for does not exist or has been moved.",
        )}
      </Typography>
    </Box>
  )
}
